import React from "react";
export const VideoBgComponent = ({ videoUrl }) => (React.createElement("div", { className: "video-bg-component" },
    React.createElement("div", { className: "video-bg-component__video-mask" }),
    React.createElement("video", { className: "video-bg-component__video-mask__video", autoPlay: true, loop: true, muted: true, playsInline: true },
        React.createElement("source", { src: videoUrl, type: 'video/mp4' }))));
